import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { bookingFailed } from 'state/quotes/booking/booking.actions';
import type { EpicWithThunk } from 'state/state.common';

export function bookingFailedEpic(): EpicWithThunk {
  return action$ =>
    action$.pipe(
      ofType(
        'BOOKING_ACK_FAILED',
        'ORDERS_BASKET_FORM_QUOTE_FAILED',
        'ORDERS_BASKET_FORM_QUOTE_TIMEOUT',
        'ORDERS_BASKET_FORM_TRADE_AUTH_FAILED',
        'ORDERS_BASKET_FORM_TRADE_AUTH_TIMEOUT',
        'ORDERS_BASKET_FORM_TRADE_FAILED',
        'ORDERS_BASKET_FORM_TRADE_TIMEOUT',
        'ORDERS_BASKET_FORM_QUOTE_REJECTED',
        'ORDERS_BASKET_FORM_TRADE_REJECTED',
        'ORDERS_BASKET_FORM_TRADE_AUTH_REJECTED',
      ),
      map(action => {
        switch (action.type) {
          case 'BOOKING_ACK_FAILED':
            return bookingFailed(action.formId, action.error, action.workspace);

          case 'ORDERS_BASKET_FORM_QUOTE_FAILED':
            return bookingFailed(
              action.formId,
              action.newVersion
                ? apiErrorHelper.toApiErrorMessage(new Error('Quote failed with new version'))
                : apiErrorHelper.toApiErrorMessage(new Error('Quote failed')),
              'ordersBasket',
            );

          case 'ORDERS_BASKET_FORM_QUOTE_TIMEOUT':
            return bookingFailed(
              action.formId,
              apiErrorHelper.toApiErrorMessage(new Error('Quote timeout')),
              'ordersBasket',
            );

          case 'ORDERS_BASKET_FORM_TRADE_AUTH_FAILED':
            return bookingFailed(action.formId, action.error, 'ordersBasket');

          case 'ORDERS_BASKET_FORM_TRADE_AUTH_TIMEOUT':
            return bookingFailed(
              action.formId,
              apiErrorHelper.toApiErrorMessage(new Error('Trade authorization timeout')),
              'ordersBasket',
            );

          case 'ORDERS_BASKET_FORM_TRADE_FAILED':
            return bookingFailed(action.formId, action.error, 'ordersBasket');

          case 'ORDERS_BASKET_FORM_TRADE_TIMEOUT':
            return bookingFailed(
              action.formId,
              apiErrorHelper.toApiErrorMessage(new Error('Trade timeout')),
              'ordersBasket',
            );

          case 'ORDERS_BASKET_FORM_QUOTE_REJECTED':
            return bookingFailed(
              action.formId,
              apiErrorHelper.toApiErrorMessage(new Error('Quote rejected')),
              'ordersBasket',
            );

          case 'ORDERS_BASKET_FORM_TRADE_REJECTED':
            return bookingFailed(
              action.formId,
              apiErrorHelper.toApiErrorMessage(new Error('Trade rejected')),
              'ordersBasket',
            );

          case 'ORDERS_BASKET_FORM_TRADE_AUTH_REJECTED':
            return bookingFailed(
              action.formId,
              apiErrorHelper.toApiErrorMessage(new Error('Trade authorization rejected')),
              'ordersBasket',
            );

          default:
            // This should never happen due to ofType filtering
            return bookingFailed(
              '',
              apiErrorHelper.toApiErrorMessage(new Error('Unknown booking failure')),
              'ordersBasket',
            );
        }
      }),
    );
}
